export enum SuperMarket {
    Carrefour = 1,
    Delhaize = 2,
    Aldi = 3,
}
